import classNames from 'classnames';
import highlightjs from 'highlight.js/lib/core';
import javascript from 'highlight.js/lib/languages/javascript';
import json from 'highlight.js/lib/languages/json';
import xml from 'highlight.js/lib/languages/xml';
import { PropsWithChildren } from 'lib-shared-types-utils';
import BareHighlight from 'react-fast-highlight/lib/js/BareHighlight';

import styles from './codeHighlight.module.scss';

highlightjs.registerLanguage('javascript', javascript);
highlightjs.registerLanguage('json', json);
highlightjs.registerLanguage('xml', xml);

/** The supported languages for highlighting. */
type CodeHighlightLanguage = 'js' | 'html' | 'json';

type CodeHighlightProps = {
  /** The languages. */
  readonly languages?: readonly CodeHighlightLanguage[];
  /** The styles pass to highlight component */
  readonly highlightClassName?: string;
} & Omit<React.HTMLAttributes<HTMLDivElement>, 'children'> &
  PropsWithChildren<string>;

/**
 * A component that parses a string and returns tokenized and colored HTML from
 * programming language configurations. Eg. JavaScript.
 */
export const CodeHighlight = ({
  children,
  languages,
  className,
  highlightClassName,
  ...rest
}: CodeHighlightProps): JSX.Element => {
  return (
    <div
      className={classNames(
        {
          [styles.root]: true,
        },
        className,
      )}
      {...rest}
    >
      <BareHighlight
        className={highlightClassName}
        highlightjs={highlightjs}
        languages={languages}
      >
        {children}
      </BareHighlight>
    </div>
  );
};
